var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.75V13.5",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.202 3.74857L2.95423 17.9978C2.82226 18.2258 2.75266 18.4846 2.75244 18.748C2.75222 19.0115 2.82139 19.2703 2.95299 19.4986C3.08459 19.7268 3.27397 19.9163 3.50209 20.0481C3.7302 20.1799 3.989 20.2493 4.25245 20.2493H20.748C21.0114 20.2493 21.2702 20.1799 21.4984 20.0481C21.7265 19.9163 21.9159 19.7268 22.0474 19.4986C22.179 19.2703 22.2482 19.0115 22.248 18.748C22.2478 18.4846 22.1782 18.2258 22.0462 17.9978L13.7984 3.74857C13.6667 3.52093 13.4774 3.33193 13.2495 3.20055C13.0216 3.06916 12.7632 3 12.5002 3C12.2372 3 11.9788 3.06916 11.7509 3.20055C11.5231 3.33193 11.3338 3.52093 11.202 3.74857V3.74857Z",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.125C13.3023 18.125 13.75 17.6773 13.75 17.125C13.75 16.5727 13.3023 16.125 12.75 16.125C12.1977 16.125 11.75 16.5727 11.75 17.125C11.75 17.6773 12.1977 18.125 12.75 18.125Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3245e8b6d0fd865d99794a4ba2a3b47c.svg";
export { ForwardRef as ReactComponent };